import * as React from "react";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import "./routes.css";
import Gift from "../img/gift.jpg";
import AnnMovement from "../img/annMovement.jpg";
import ReactiveTriadsDvD from "../img/reactiveTriadsDvd.jpg";
import GiftCertificate from "../PaypalButtons/giftCertificate";

// FUTURE: individual Conscious Anatomy class purchases via PayPal.
// To enable, uncomment this list and the {/* classLinks */} block inside the
// Conscious Anatomy card below.
// const classLinks = [
//   { title: "Planes and Directions", url: "https://www.paypal.com/ncp/payment/2NJLKRG5RHA2S" },
//   { title: "Basic Bones", url: "https://www.paypal.com/ncp/payment/XZ7PCFHHKTT72" },
//   { title: "The Cranium", url: "https://www.paypal.com/ncp/payment/TZ5GNSRHKEDN6" },
//   { title: "The Carpals and Tarsals", url: "https://www.paypal.com/ncp/payment/VDST9XHNJUKAG" },
//   { title: "The Shoulder Girdle", url: "https://www.paypal.com/ncp/payment/WJSSH27DENWD6" },
//   { title: "Spine and Voice", url: "https://www.paypal.com/ncp/payment/D644UGPJ2KU9S" },
//   { title: "The Pelvis: Focusing on Somatic Awareness and Energetic Attunement", url: "https://www.paypal.com/ncp/payment/LPPKFNU73994G" },
//   { title: "Sound Healing and Revel in Your Deeper Knowledge of Anatomy", url: "https://www.paypal.com/ncp/payment/YQHBKPCUEDCBQ" },
// ];

function Store() {
  return (
    <div className="pageBg">
      <div className="container">
        <div className="pageCard">
          <h2 className="pageTitle">Store</h2>

          <p className="pageLead">
            Gift certificates, Ann&rsquo;s Reactive Triads™ DVD, mentoring, and
            Conscious Anatomy™ trainings.
          </p>

          <h4 className="subTitle">How to purchase</h4>
          <p>
            Use our secure online PayPal checkout below, or call, write, or
            email us. Make sure to give us your phone number and we&rsquo;ll
            call you to process your order.
          </p>
          <div className="missionQuote">
            <strong>Please do not put credit card information in an email</strong>{" "}
            to us. Email is not a secure way to send it.
          </div>

          {/* Gift Certificate */}
          <div className="productCard" id="giftcertificate">
            <div className="profile">
              <img src={Gift} className="profilePhoto" alt="Gift certificate" />
              <div className="profileBody">
                <h4 className="profileName">Massage Gift Certificate</h4>
                <p className="profileCred">
                  Good for a session with{" "}
                  <Link to="/about">Ann Watkins, MA, LMT #000393, or our staff</Link>
                </p>
                <p className="price">
                  $110.00 for 1 hour, plus $25.00 for every 15 minutes after
                  that.
                </p>
                <p>
                  Print out the PayPal receipt and use that as the gift
                  certificate confirmation until you receive the Gift
                  Certificate in the mail. In a rush? Call us at{" "}
                  <a href="tel:8605994533">(860) 599-4533</a>.
                </p>
                <GiftCertificate />
                <p className="archiveFootnote">
                  Trouble with the button?{" "}
                  <a
                    href="https://www.paypal.com/ncp/payment/ACKSY7R7CT45Y"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Open the PayPal page ››
                  </a>
                </p>
              </div>
            </div>
          </div>

          {/* Reactive Triads DVD */}
          <div className="productCard" id="reactivetriadsdvd">
            <div className="profile">
              <img
                src={ReactiveTriadsDvD}
                className="profilePhoto"
                alt="Reactive Triads 2 disc DVD"
              />
              <div className="profileBody">
                <h4 className="profileName">Reactive Triads™ 2 Disc DVD</h4>
                <p className="profileCred">
                  A Breakthrough in Chronic Pain Relief, published 2006
                </p>
                <p>
                  Reactive Triads™ are three elements activated in the body
                  that cause a muscle to switch off resulting in muscle pain,
                  nerve pain, limited range of motion. Integrating lymphatic
                  drainage and jolts, Reactive Triads™ are exceptionally
                  effective in solving chronic pain problems due to muscle
                  imbalance caused by injury, whiplash, repetitive motion and
                  stress.
                </p>
                <p>
                  This DVD set documents Ann Watkins&rsquo; original bodywork
                  involving the muscle system, the lymphatic system and the
                  joint system. Great for neuronerds, and a great supplement to
                  Ann&rsquo;s courses.
                </p>
                <div className="btnRow">
                  <a
                    href="https://www.bodymindspiritanatomy.com/offers/tEMaQJqu"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Button>Buy the DVD ››</Button>
                  </a>
                  <Link to="/classes">
                    <Button variant="outline-primary">
                      Reactive Triads™ Classes ››
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Conscious Anatomy */}
          <div className="productCard" id="consciousanatomy">
            <div className="profile">
              <img
                src={AnnMovement}
                className="profilePhoto"
                alt="Ann Watkins teaching Conscious Anatomy movement"
              />
              <div className="profileBody">
                <h4 className="profileName">Conscious Anatomy™ Trainings</h4>
                <p className="profileCred">
                  Online, at your own pace, with live Q&amp;A sessions
                </p>
                <p>
                  Embark on becoming a sponge for anatomy terms and concepts
                  with blended, online, interactive, blissful movement flow
                  trainings in Conscious Anatomy™, offering tools specific to
                  your self care needs.
                </p>
                <p>
                  Drop the drudgery of crunched posture from studying anatomy
                  in books and discover ease of learning anatomy through
                  blissful, flowing movement, right down to your fingertips.
                  From the comfort of your own home, enjoy online audio
                  classes supplemented with video, coupled with live conference
                  call Q&amp;A sessions.
                </p>
                <div className="btnRow">
                  <a
                    href="https://www.bodymindspiritanatomy.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Button>Courses &amp; Free Sample Class ››</Button>
                  </a>
                  <Link to="/classes">
                    <Button variant="outline-primary">Class Details ››</Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* FUTURE: Individual Conscious Anatomy class purchases via PayPal.
              Step 1: uncomment the `classLinks` list at the top of this file.
              Step 2: uncomment this card. Each link opens its PayPal payment page.

          <div className="productCard" id="classpurchases">
            <h4 className="profileName">Conscious Anatomy™ Classes</h4>
            <p className="profileCred">Purchase individual classes</p>
            <ul className="courseList">
              {classLinks.map((c) => (
                <li key={c.url}>
                  <a href={c.url} target="_blank" rel="noreferrer">
                    <strong>{c.title}</strong>
                    <span>See details and purchase ››</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          END FUTURE */}

          {/* Supervision & Mentoring */}
          <div className="productCard" id="supervision">
            <h4 className="profileName">Supervision &amp; Mentoring</h4>
            <p className="profileCred">
              In person, by phone, or over Zoom
            </p>
            <p>
              I am available to help you build greater confidence and a more
              effective practice through supervision and mentoring. Prepare
              your questions before each call and I will provide you with
              helpful guidance. I&rsquo;ve had a thriving practice since 1988
              and can answer questions on how to build a practice from the
              ground up with guidance on how to more effectively treat your
              clients. This is especially useful if you have taken courses with
              me and are applying the work in sessions with your clients.
            </p>
            <p>
              Interested in an internship to practice your skills while still
              in massage school? This is a perfect place for that.
            </p>
            <p className="price">
              Phone mentoring: $40.00 per half hour. Free consultation to see
              if this is right for you.
            </p>
            <p style={{ marginBottom: 0 }}>
              Call <a href="tel:8605994533">(860) 599-4533</a> or email{" "}
              <a href="mailto:bodymindspiritanatomy@gmail.com">
                bodymindspiritanatomy@gmail.com
              </a>{" "}
              to get started.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Store;
